var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeSolid = function SvgLikeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 29 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.98 24.71h4.478c2.596 0 4.86-1.708 5.489-4.142l2.293-8.866c.447-1.726-.904-3.398-2.744-3.398H18.51l1.849-3.062c1.375-2.279-.326-5.14-3.055-5.14h-1.623l-5.472 9.254c-.122.207-.186.44-.186.679v11.209c0 .457.236.884.63 1.137l2.188 1.41a5.8 5.8 0 0 0 3.139.919M3.657 8.304h1.415C6.634 8.304 7.9 9.53 7.9 11.04v9.57c0 1.51-1.267 2.734-2.83 2.734H3.658c-1.562 0-2.829-1.224-2.829-2.734v-9.57c0-1.51 1.267-2.735 2.83-2.735",
    clipRule: "evenodd"
  })));
};
export default SvgLikeSolid;